import shop from '../../api/shop'
import * as types from '../mutation-types'

// initial state
const state = {
  all: [],
  currentId:0,
}

// getters
const getters = {
  allOrders: state => state.all,
  currentOrderId: state => state.currentId,
}


// actions
const actions = {
  getAllOrders ({ commit }, cb) {
    shop.getOrders(orders => {
      commit(types.GET_ORDERS, { orders })
      cb && cb()
    })
  },
  setCurrentId({ commit }, currentId) {
    commit(types.SET_ORDER_ID, currentId);
  }
}


// mutations
const mutations = {
  [types.GET_ORDERS] (state, { orders }) {
    state.all = orders
  },
  [types.SET_ORDER_ID] (state, {currentId}) {
    state.currentId = currentId;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js